import script from "./AmplopDigital.vue?vue&type=script&setup=true&lang=js"
export * from "./AmplopDigital.vue?vue&type=script&setup=true&lang=js"

import "./AmplopDigital.vue?vue&type=style&index=0&id=092e38a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-092e38a3"]])

export default __exports__